<template>
	<div class="filters">
		<div class="field">
			<div class="control has-icons-left">
				<input
					v-model="filterBy"
					class="input"
					type="search"
					placeholder="Filter"
				/>
				<span class="icon is-left">
					<i class="fas fa-search"></i>
				</span>
			</div>
		</div>
		<field-checkbox @change="updateSort"
			>Display as A-Z list</field-checkbox
		>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "AppChartFilters",
	data() {
		return {
			sortBy: true
		};
	},
	computed: {
		...mapGetters({ filter: "filtersModule/filterby" }),
		filterBy: {
			get() {
				return this.filter;
			},
			set(value) {
				this.setFilterBy(value);
			}
		}
	},
	methods: {
		...mapActions({ setFilterBy: "filtersModule/setFilterBy" }),
		updateSort(value) {
			console.log(value);
		}
	}
};
</script>

<style lang="scss">
.filters {
	padding: 0.25rem 0.9rem;
	margin-bottom: 1rem;
}
</style>
